
























































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({ name: 'v-path' })
export default class VPath extends Vue {
    /**
     * List of vault/logins to show in the path.
     * The last element will always be visible
     */
    @Prop({ type: Array, default: () => [] })
    path!: string[]

    /**
     * Link for the entire path
     */
    @Prop({ type: String })
    link?: string

    /**
     * List of links that match with path names
     */
    @Prop({ type: Array, default: () => [] })
    pathLinks!: string[]

    @Prop({ type: String, default: null })
    invert!: 'light' | 'dark'

    @Prop({ type: String, default: 'white' })
    type!: 'white' | 'black'

    @Prop({ type: String, default: 'md' })
    size!: 'md' | 'lg'

    @Prop({ type: Boolean, default: false })
    trailing!: boolean

    get truthyPath(): string[] {
        return this.path.filter(v => !!v)
    }

    /**
     * Element type
     */
    get element(): string {
        return this.link ? 'span' : 'a'
    }

    /**
     * Last element in path array
     */
    get last(): string {
        return this.truthyPath[this.truthyPath.length - 1]
    }

    /**
     * All but the last element in the path array
     */
    get folderPath(): string[] {
        return this.truthyPath.slice(0, -1)
    }
}
